import React, { useState, useRef, useEffect } from 'react';

const RadioPlayer = () => {
  const [isPlaying, setIsPlaying] = useState(false);
  const [radioUrl, setRadioUrl] = useState('http://redir.atmcdn.pl/sc/o2/Eurozet/live/antyradio.livx');
  const [volume, setVolume] = useState(1);
  const [error, setError] = useState('');
  const audioRef = useRef(null);

  useEffect(() => {
    if (audioRef.current) {
      audioRef.current.pause();
    }

    audioRef.current = new Audio(radioUrl);
    audioRef.current.volume = volume;
    audioRef.current.onerror = () => {
      setError('Błąd ładowania stacji radiowej. Sprawdź link.');
    };

    if (isPlaying) {
      audioRef.current.play();
    }
// eslint-disable-next-line react-hooks/exhaustive-deps
}, [radioUrl, volume]);



  const togglePlayPause = () => {
    if (isPlaying) {
      audioRef.current.pause();
    } else {
      audioRef.current.play();
    }
    setIsPlaying(!isPlaying);
  };

  return (
    <div className="radio-player">
      <h2>Odtwarzacz Radiowy</h2>

      {/* Wybór stacji radiowej */}
      <div>
        <label htmlFor="radio-select">Wybierz stację:</label>
        <select id="radio-select" onChange={(e) => setRadioUrl(e.target.value)} value={radioUrl}>
          <option value="http://redir.atmcdn.pl/sc/o2/Eurozet/live/antyradio.livx">Antyradio</option>
          <option value="http://streaming.radio.co/s7ed262470/listen">Radio ZET</option>
          <option value="http://streaming.radio.co/s5a30132d4/listen">RMF FM</option>
          <option value="http://streaming.radio.co/s4be947c6c/listen">Radio Maryja</option>
        </select>
      </div>

      {/* Przycisk odtwarzania */}
      <button onClick={togglePlayPause}>
        {isPlaying ? 'Pauza' : 'Odtwórz'}
      </button>

      {/* Regulacja głośności */}
      <div>
        <label htmlFor="volume">Głośność:</label>
        <input
          type="range"
          id="volume"
          min="0"
          max="1"
          step="0.01"
          value={volume}
          onChange={(e) => setVolume(e.target.value)}
        />
        <span>{Math.round(volume * 100)}%</span>
      </div>

      {/* Błąd ładowania */}
      {error && <div className="error-message">{error}</div>}
    </div>
  );
};

export default RadioPlayer;
